import { Box, Typography } from "@dealer-center/core-components";
import type { DetailComponentProps } from "../../MasterDetailLayout";

export const WebFormItemDetail = ({ selectedId }: DetailComponentProps) => {
  if (!selectedId) {
    return (
      <Box sx={{ color: "text.secondary", p: 4, textAlign: "center" }}>
        <Typography variant="body-md">
          Select a Website Form to view details
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6">Website Form Detail — {selectedId}</Typography>
      <Typography sx={{ color: "text.secondary", mt: 1 }} variant="body-md">
        TODO: render Website Form detail for {selectedId}
      </Typography>
    </Box>
  );
};
